module.exports = __webpack_public_path__ + "c2f2e468feed077d169ac8e1f5da6480.fbx";